import { Button, LuIcon } from "@overmap-ai/blocks"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const TeamSettingsDetailViewTopBar = memo(() => {
	return (
		<BaseTopBar
			showAIButton={false}
			leftContent={
				<Link from="/$organizationId/settings/teams/$teamId" to="/$organizationId/settings/teams">
					<Button variant="ghost" accentColor="base">
						<LuIcon icon={modelIconMapping.arrowLeft} />
						Teams
					</Button>
				</Link>
			}
		/>
	)
})
TeamSettingsDetailViewTopBar.displayName = "TeamSettingsDetailViewTopBar"
